import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'

import routes from 'src/lib/rails-routes/rails-routes'
import DateUtil from 'src/lib/date-util'
import { t } from 'src/lib/i18n-react'
import { Flex, Text, Image } from '@chatterbug/aaron'
import { getLocale } from 'src/config/globals'
import ActionsList from 'src/ui/Action/ActionsList'
import Action from 'src/ui/Action/Action'
import AchievementWidget from 'src/pages/Achievements/subcomponents/AchievementWidget/AchievementWidget'

import FlashcardsGraph from './subcomponents/FlashcardsGraph/FlashcardsGraph'
import flashcards from './assets/flashcards.svg'
import FlashcardsWidgetSkeleton from './FlashcardsWidgetSkeleton'
const LOCALE = getLocale() || 'en'

const FlashcardsWidget = ({
  l2Code,
  data,
  totalCards,
  totalHours,
  totalKnownCards,
  lastCardActivity,
  showPlaceholder,
}) => {
  const { labels, datasets } = data

  const date = DateUtil.format(
    moment()
      .locale(LOCALE)
      .utc()
      .subtract(90, 'days'),
    'MMMM D, YYYY'
  )
  return (
    <FlashcardsWidgetSkeleton
      headerSection={
        <Flex>
          <Image src={flashcards} />
          <Text fontWeight="bold">{t('Flashcards')}</Text>
        </Flex>
      }
      graphSection={
        !showPlaceholder && (
          <>
            <Text fontSize="xxs" fontWeight="bold">
              {t('%{date} - Today', { date })}
            </Text>
            <FlashcardsGraph
              date={date}
              data={{
                labels: labels,
                datasets: datasets,
              }}
            />
          </>
        )
      }
      statsSection={
        <AchievementWidget
          widgetType="flashcards"
          showPlaceholder={showPlaceholder}
          activityInfo={lastCardActivity}
          footerStats={[
            { number: totalCards, label: t('total cards') },
            { number: totalKnownCards, label: t('known well') },
            { number: totalHours, label: t('hours of study') },
          ]}
          boxShadow={null}
          p={0}
        />
      }
      footerSection={
        !showPlaceholder && (
          <ActionsList>
            <Action href={routes.cards(l2Code)}>{t('Study Standard')}</Action>
          </ActionsList>
        )
      }
      showPlaceholder={showPlaceholder}
    />
  )
}

FlashcardsWidget.propTypes = {
  l2Code: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  lastCardActivity: PropTypes.object.isRequired,
  totalCards: PropTypes.number.isRequired,
  totalHours: PropTypes.number.isRequired,
  totalKnownCards: PropTypes.number.isRequired,
  showPlaceholder: PropTypes.bool.isRequired,
}

export default FlashcardsWidget
